// Moglee Base — cart drawer.
// Adds to cart without a page reload. The drawer draws itself from the live
// cart (/cart.js). Right after an add the cart can briefly still show its old
// contents, so after adding we ask again until the new item shows up.

(function () {
  // The cart page and the drawer section both load this file. Only the first
  // copy may run, or every action would happen twice.
  if (window.__mbCartReady) return;
  window.__mbCartReady = true;

  var root = document.documentElement;
  var drawer = document.querySelector('[data-mb-cart-drawer]');
  if (!drawer) return;

  var lastFocus = null;
  var snapshot = null; // the last cart we saw

  function routeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function attr(name) {
    return drawer.getAttribute('data-' + name) || '';
  }

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function digits(cents, places, thousands, decimal) {
    var parts = (cents / 100).toFixed(places).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts[1] ? whole + decimal + parts[1] : whole;
  }

  function money(cents, withCurrency) {
    var format = attr(withCurrency ? 'money-currency-format' : 'money-format') || '{{amount}}';
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, name) {
      var places = name.indexOf('no_decimals') === -1 ? 2 : 0;
      return name.indexOf('comma') === -1 ? digits(cents, places, ',', '.') : digits(cents, places, '.', ',');
    });
  }

  function open() {
    lastFocus = document.activeElement;
    root.setAttribute('data-mb-cart-open', 'true');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var close = drawer.querySelector('[data-mb-cart-close]');
    if (close) close.focus();
  }

  function close() {
    root.removeAttribute('data-mb-cart-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function updateCount(cart) {
    document.querySelectorAll('[data-mb-cart-count]').forEach(function (node) {
      node.textContent = cart.item_count;
      node.classList.toggle('mb-header__count--zero', cart.item_count === 0);
    });
  }

  function lineHtml(item) {
    var picture = item.image || (item.featured_image && item.featured_image.url) || '';
    if (picture) picture += (picture.indexOf('?') === -1 ? '?' : '&') + 'width=240';
    var down = item.quantity - 1;
    var up = item.quantity + 1;
    var key = esc(item.key);

    return (
      '<li class="mb-line" data-key="' + key + '">' +
      '<a class="mb-line__media" href="' + esc(item.url) + '" tabindex="-1" aria-hidden="true">' +
      (picture ? '<img src="' + esc(picture) + '" alt="' + esc(item.product_title) + '" loading="lazy">' : '') +
      '</a>' +
      '<div>' +
      '<p class="mb-line__title"><a href="' + esc(item.url) + '">' + esc(item.product_title) + '</a></p>' +
      (item.product_has_only_default_variant || !item.variant_title
        ? ''
        : '<p class="mb-line__meta">' + esc(item.variant_title) + '</p>') +
      (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
        ? '<p class="mb-line__meta">' + esc(item.selling_plan_allocation.selling_plan.name) + '</p>'
        : '') +
      '<div class="mb-line__row">' +
      '<div class="mb-qty">' +
      '<button type="button" data-mb-qty data-key="' + key + '" data-qty="' + down + '" aria-label="Reduce quantity"' +
      (item.quantity <= 1 ? ' disabled' : '') + '>&minus;</button>' +
      '<span>' + item.quantity + '</span>' +
      '<button type="button" data-mb-qty data-key="' + key + '" data-qty="' + up + '" aria-label="Increase quantity">+</button>' +
      '</div>' +
      '<span class="mb-line__price">' + esc(money(item.final_line_price)) + '</span>' +
      '</div>' +
      '<button type="button" class="mb-line__remove" data-mb-remove data-key="' + key + '">Remove</button>' +
      '</div>' +
      '</li>'
    );
  }

  function render(cart) {
    snapshot = cart;
    var html =
      '<div class="mb-cart-drawer__head">' +
      '<h2 class="mb-cart-drawer__title">' + esc(attr('heading')) + ' (' + cart.item_count + ')</h2>' +
      '<button type="button" class="mb-cart-drawer__close" data-mb-cart-close aria-label="Close">&times;</button>' +
      '</div>' +
      '<div class="mb-cart-drawer__body">';

    if (cart.item_count > 0) {
      html += '<ul class="mb-line-items">' + cart.items.map(lineHtml).join('') + '</ul></div>';
      html +=
        '<div class="mb-cart-drawer__foot">' +
        '<div class="mb-cart-total"><span>Subtotal</span><span>' + esc(money(cart.total_price, true)) + '</span></div>' +
        (attr('note') ? '<p class="mb-cart-note">' + esc(attr('note')) + '</p>' : '') +
        '<form action="' + esc(attr('cart-url')) + '" method="post">' +
        '<button type="submit" name="checkout" class="mb-checkout">' + esc(attr('checkout-label')) + '</button>' +
        '</form>' +
        '<a class="mb-cart-link" href="' + esc(attr('cart-url')) + '">View cart</a>' +
        '</div>';
    } else {
      html +=
        '<div class="mb-cart-empty"><p>' + esc(attr('empty-text')) + '</p>' +
        '<p><a class="mb-cart-link" href="' + esc(attr('all-url')) + '">Continue shopping</a></p></div></div>';
    }

    drawer.innerHTML = html;
    updateCount(cart);
  }

  // Reads the cart fresh, never from the browser cache.
  function getCart() {
    return fetch(routeRoot() + 'cart.js?t=' + Date.now(), {
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        snapshot = cart;
        return cart;
      });
  }

  // After an add, keeps asking until the cart holds at least minCount items
  // (about four seconds at most), then returns the freshest cart it saw.
  function settle(minCount) {
    var tries = 0;

    function attempt() {
      return getCart().then(function (cart) {
        if (cart.item_count >= minCount) return cart;
        if (tries >= 12) {
          setTimeout(function () {
            getCart().then(render).catch(function () {});
          }, 2500);
          return cart;
        }
        tries += 1;
        return new Promise(function (resolve) {
          setTimeout(resolve, 350);
        }).then(attempt);
      });
    }

    return attempt();
  }

  function refresh(minCount) {
    return (minCount ? settle(minCount) : getCart()).then(render).catch(function (error) {
      console.error('[Moglee cart] could not refresh the drawer', error);
    });
  }

  // Add to cart from any product form.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.action || form.action.indexOf('/cart/add') === -1) return;

    event.preventDefault();
    var button = form.querySelector('[type="submit"]');
    var label = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'Adding…';
    }

    var data = new FormData(form);
    var quantity = parseInt(data.get('quantity'), 10) || 1;
    var wanted = 0;

    getCart()
      .catch(function () {
        return { item_count: snapshot ? snapshot.item_count : 0 };
      })
      .then(function (before) {
        wanted = before.item_count + quantity;
        return fetch(routeRoot() + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: data
        });
      })
      .then(function (response) {
        return response.json().then(function (body) {
          if (!response.ok) throw body;
          return body;
        });
      })
      .then(function () {
        return refresh(wanted);
      })
      .then(open)
      .catch(function (error) {
        console.error('[Moglee cart] add to bag failed', error);
        if (error && error.description) {
          window.alert(error.description);
        } else {
          form.submit();
        }
      })
      .finally(function () {
        if (button) {
          button.disabled = false;
          button.textContent = label;
        }
      });
  });

  // Quick add sheet (assets/mb-quickadd.js): note the cart when the sheet is
  // ready, and once an item has been added wait for it, then show the drawer.
  document.addEventListener('mb:qa:ready', function (event) {
    var sheet = event.detail;
    new MutationObserver(function () {
      var state = sheet.wrap.getAttribute('data-state');
      if (state === 'ready') {
        getCart().catch(function () {});
        return;
      }
      if (state !== 'added') return;
      var wanted = (snapshot ? snapshot.item_count : 0) + 1;
      refresh(wanted).then(function () {
        sheet.close();
        open();
      });
    }).observe(sheet.wrap, { attributes: true, attributeFilter: ['data-state'] });
  });

  // Quantity changes and removals inside the drawer or on the cart page.
  function change(key, quantity) {
    var container = document.querySelector('[data-mb-cart-open] [data-mb-cart-drawer]') || drawer;
    container.setAttribute('aria-busy', 'true');

    fetch(routeRoot() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        render(cart);
        if (document.querySelector('[data-mb-cart-page]')) window.location.reload();
      })
      .catch(function (error) {
        console.error('[Moglee cart] could not change the cart', error);
        window.location.reload();
      })
      .finally(function () {
        container.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-mb-cart-toggle]');
    if (opener) {
      event.preventDefault();
      open();
      refresh();
      return;
    }

    if (event.target.closest('[data-mb-cart-close]') || event.target.closest('[data-mb-cart-overlay]')) {
      event.preventDefault();
      close();
      return;
    }

    var step = event.target.closest('[data-mb-qty]');
    if (step) {
      event.preventDefault();
      change(step.getAttribute('data-key'), parseInt(step.getAttribute('data-qty'), 10));
      return;
    }

    var remove = event.target.closest('[data-mb-remove]');
    if (remove) {
      event.preventDefault();
      change(remove.getAttribute('data-key'), 0);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && root.getAttribute('data-mb-cart-open') === 'true') close();
  });

  // Coming back to the page from the browser cache: make sure the drawer is current.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) refresh();
  });

  // Note what is in the cart as soon as the page loads.
  getCart().catch(function () {});
})();